import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { GlobalsService } from "../../api/globals.service";
import * as $ from "jquery";
import { AuthService } from "src/app/services/auth.service";
import { EbooksService } from "src/app/services/ebooks.service";
import { EncriptadorService } from "src/app/services/encriptador.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

import { HttpClient } from "@angular/common/http";
import { error } from "console";

@Component({
  selector: "app-pdf",
  templateUrl: "./pdf.component.html",
  styleUrls: ["./pdf.component.scss"],
})
export class PdfComponent implements OnInit {
  @Input() file: any = null;
  @Output() isModalOpenChange = new EventEmitter<boolean>();
  public ismobile: boolean;
  public filePdf: any = null;
  safePdfBase64String: SafeResourceUrl;
  dataLoaded = false;

  displayUserData: any;
  auth_key: string;
  id_user: number;
  private init: number = 0;
  constructor(
    public globalsService: GlobalsService,
    private authService: AuthService,
    private ebooksService: EbooksService,
    private encriptService: EncriptadorService,
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {
    this.ismobile = this.globalsService.isMobile;
    this.safePdfBase64String =
      this.sanitizer.bypassSecurityTrustResourceUrl("");
  }
  public b64Data = "";
  ngOnInit() {
    this.ismobile = this.globalsService.isMobile;
    console.log("🚀 ~ PdfComponent ~ ngOnInit ~ this.file:", this.file)
    let ext = this.file.nombre_archivo.split(".").pop();
    if (ext != "pdf") {
      return;
    }
    this.authService.userData$.subscribe((res: any) => {
      this.displayUserData = res;
      let auth_key = this.displayUserData?.auth_key;
      this.id_user = this.displayUserData?.id;
      if (auth_key != undefined) {
        this.auth_key = this.displayUserData?.auth_key;
        let jsondata = {
          id_user: this.id_user,
          auth_key: this.auth_key,
          file: this.file.nombre_archivo,
          tipo: ext,
          id_pro: 2,
        };
        let encrypt = this.encriptService.encrypt(JSON.stringify(jsondata));
        this.ebooksService
          .getEbook(this.id_user, this.auth_key, encrypt)
          .subscribe(
            (blob: Blob) => {
              const pdfBlob = new Blob([blob], { type: "application/pdf" });
              this.filePdf = URL.createObjectURL(pdfBlob);
              this.dataLoaded = true;
            },
            (error) => {
              this.dataLoaded = true;
            }
          );
      }
    });
  }

  ngOnDestroy() {
    if (this.filePdf?.startsWith("blob:")) {
      URL.revokeObjectURL(this.filePdf);
    }
  }
}
